import { Outlet, createFileRoute } from '@tanstack/react-router';
import { layoutTexts } from '@/components/layout/texts';

/** Pages without a session: sign-in, invitation, TOTP setup, password reset. */
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <main className="bg-muted/40 flex min-h-svh flex-col items-center justify-center gap-6 p-4">
      <div className="flex items-center gap-2">
        <img src="/favicon.svg" alt="" className="size-8 rounded-md" />
        <span className="text-lg font-semibold">{layoutTexts.appName}</span>
      </div>
      <Outlet />
    </main>
  );
}
